import { render } from "./LessonView.vue?vue&type=template&id=679548d9"
import script from "./LessonView.vue?vue&type=script&lang=js"
export * from "./LessonView.vue?vue&type=script&lang=js"

import "./LessonView.vue?vue&type=style&index=0&id=679548d9&lang=scss"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__